import { render, staticRenderFns } from "./NavigationTop.vue?vue&type=template&id=635df984&scoped=true&"
import script from "./NavigationTop.vue?vue&type=script&lang=js&"
export * from "./NavigationTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635df984",
  null
  
)

export default component.exports